module.exports = __webpack_public_path__ + "img/guandao-min.43c21efe.jpg";